import { FN_Backend, FN_Backend_API, Talent_Backend } from 'src/config/env';

const API_ENDPOINTS = {
  login: `${FN_Backend }login/`,

  jobSearchConfigs: (jobId) => `${FN_Backend_API }jd/${jobId}/searches/`,
  searches: `${FN_Backend_API }searches/`,

  watches: `${FN_Backend_API }watches/`,
  watchesDetails: `${FN_Backend_API }watches/candidate_detail/`,
  watchesConnect: `${FN_Backend_API }watches/connect/t500/`,
  watchesRemove: `${FN_Backend_API }watches/remove/`,

  workflows: `${FN_Backend_API }workflows/`,
  outreach: `${FN_Backend_API }workflows/send-email/`,

  candidateSearch: `${FN_Backend_API }candidates`,

  candidateExport: `${FN_Backend_API }candidates/export_data/`,

  candidateTracker: `${FN_Backend_API }watches`,

  analyticsTrackerCandidateContacted: `${FN_Backend_API }analytics/tracker/candidate_contacted?job_id=`,
  analyticsTrackerCandidateApplied: `${FN_Backend_API }analytics/tracker/candidate_applied?job_id=`,
  analyticsTrackerCandidateHired: `${FN_Backend_API }analytics/tracker/candidate_hired?job_id=`,

  candidateDetails: (candidateId) => `${FN_Backend_API }candidates/${candidateId}`,

  jobSearch: `${FN_Backend_API }jobs`,
  jobDetails: (jobId, jobUpiId) => `${FN_Backend_API }job_fetch/?job_id=${jobId}&job_upi_id=${jobUpiId}`,

  autoSuggest: (query, type) => `${FN_Backend_API }auto-suggest/?limit=200&q=${query}&type=${type}`,
  autoSuggestCities: (query, type, countries) => `${FN_Backend_API }auto-suggest/?limit=200&q=${query}&type=${type}&country_code=${countries}`,

  history: (email) => `${FN_Backend_API }candidate-history?email=${email}`,

  jobTitle: (query, type) => `${Talent_Backend }api/auto_suggest/?limit=200&q=${query}&type=${type}`,

  bulkActions: `${FN_Backend_API }watches/bulk_actions/`,
  similarskills: (query) => `${FN_Backend_API}similar-suggest/skill/?skill=${query}`,
};
export default API_ENDPOINTS;
